/**
 * The boards on the page, by name: `boards.study`, `boards.line`, and whatever the next tool calls
 * its own. Each holds what its position is — fen, turn, history, which way round it is drawn — and
 * nothing that is not data: the Chess and the Chessground of a board live in state/live.ts.
 *
 * It starts empty because a board writes its own corner the moment it is made.
 */
export const boardsSlice = {};
